import * as React from "react"
import {useMemo} from "react";
import {mergeDicts} from "@utils";
import {useTheme} from "@mui/material";

import MinimalThemeProvider from "../Minimal";
import overrideAnalyticComponents from "./overrides";
import {analyticPalette} from "./palette";


export default function AnalyticsThemeProvider({ global={}, palette={}, shape={}, typography={}, overrides=()=>({}), children }) {

	const themeOptions = useMemo(() => ({
		palette: mergeDicts(analyticPalette, palette),
	}), [])

	return <MinimalThemeProvider
		global={global}
		palette={themeOptions.palette}
		shape={shape}
		typography={typography}
		overrides={theme => mergeDicts(overrideAnalyticComponents(theme), overrides(theme))}
	>
		{children}
	</MinimalThemeProvider>
}